import { render, staticRenderFns } from "./AppNavbarFull.vue?vue&type=template&id=64cd70d2&scoped=true&"
import script from "./AppNavbarFull.vue?vue&type=script&lang=js&"
export * from "./AppNavbarFull.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarFull.vue?vue&type=style&index=0&id=64cd70d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd70d2",
  null
  
)

export default component.exports